/* unplugin-vue-components disabled */import { render } from "./advantage.vue?vue&type=template&id=8e58f3fe&scoped=true"
import script from "./advantage.vue?vue&type=script&lang=js"
export * from "./advantage.vue?vue&type=script&lang=js"

import "./advantage.vue?vue&type=style&index=0&id=8e58f3fe&scoped=true&lang=css"

import exportComponent from "F:\\vue2.0+ vant\\2024年项目集合\\元羿官网项目集合\\元羿英文版本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e58f3fe"]])

export default __exports__